// @flow

import { map, join, compose, is, isNil } from 'ramda'

type FormPairs = { key: string, value: string }
type Values = { [string]: boolean | string }

const formatToString = (value: any): string => {
  const isValueString = is(String, value)
  const isValueNil = isNil(value)

  if (!isValueString) return String(value)
  if (isValueNil) return ''

  return value
}

const changeToUriFormat =
  (form: Values) =>
  (key: string): FormPairs => {
    const field = form[key]
    return {
      key,
      value: formatToString(field),
    }
  }

const encodeKeyValuePairs = ({ key, value }: FormPairs) =>
  `${encodeURIComponent(key)}=${encodeURIComponent(value)}`

export const netlifyFormsEncode = (form: Values): string => {
  const formKeys = Object.keys(form)
  const uriFormat = changeToUriFormat(form)
  const convertToUriAndEncodeData = map(compose(encodeKeyValuePairs, uriFormat))
  const joinList = join('&')

  return compose(joinList, convertToUriAndEncodeData)(formKeys)
}

export default netlifyFormsEncode
